import { useChat } from "@/features/chat";

import Star01 from "@/assets/img/profile/star_01.webp";
import StarsMask from "@/assets/img/profile/stars_mask_group.webp";

interface StarsBalanceProps {
  onTopUp: () => void;
}

/** Stars balance card + daily-streak ladder. Ported from ProfileV4 StarsBalance. */
export function StarsBalance({ onTopUp }: StarsBalanceProps) {
  const { userCreditsCount } = useChat();

  return (
    <div className="mt-10 flex flex-col gap-4 px-4">
      <div className="relative flex min-h-[196px] overflow-hidden rounded-[20px] bg-dark-surface">
        <div className="z-[1] flex w-[222px] flex-col gap-4 px-4 pb-6 pt-4">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <img
                src={Star01}
                alt="Stars"
                className="size-10 object-contain"
              />
              <span className="font-display text-[40px] font-bold text-purple-light">
                {userCreditsCount ?? 0}
              </span>
            </div>
            <p className="font-body text-sm text-purple-light/70">
              More Stars, More Insight. Love, life &amp; your next move.
            </p>
          </div>

          <button
            type="button"
            onClick={onTopUp}
            className="flex h-11 w-fit items-center justify-center rounded-full bg-gradient-to-b from-peach to-purple-accent px-6 font-body text-base font-semibold text-white transition-opacity hover:opacity-85"
          >
            Top up balance
          </button>
        </div>

        <img
          src={StarsMask}
          alt=""
          aria-hidden
          className="pointer-events-none absolute -top-3 right-0 h-[220px] w-40 select-none object-cover"
        />
      </div>
    </div>
  );
}
